// step10.js - Additional Taskings (FIXED to match parser template exactly)
import React from 'react';
import ModernDataTable from '../ui/ModernDataTable';

const Step10 = ({ additionalTaskingItems, setAdditionalTaskingItems, defaultDateTime }) => {
  const taskingFields = [
    {
      name: 'requestTime', // ← FIXED: Was 'taskDateRaised'
      type: 'datetime',
      label: 'Task Date/Time Raised',
      header: 'Request Time',
      required: true,
      validationMessage: 'Please enter when this additional task was assigned or identified',
      hint: 'Record the exact date and time when this additional task was requested, assigned, or identified as necessary.'
    },
    {
      name: 'taskDescription',
      type: 'textarea',
      label: 'Task Description',
      header: 'Description',
      placeholder: 'Describe the additional task that was required...',
      required: true,
      validationMessage: 'Please provide a detailed description of the additional task',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Describe the additional task including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Specific nature of the task or responsibility</li>
            <li>Why this additional work was necessary</li>
            <li>Scope and complexity of the task</li>
            <li>Any special skills or resources required</li>
            <li>Expected outcome or deliverable</li>
          </ul>
        </div>
      )
    },
    {
      name: 'taskRequestedBy', // ← FIXED: Was 'requestedBy'
      type: 'text',
      label: 'Requested/Assigned By',
      header: 'Requested By',
      placeholder: 'Full name and title of person who assigned this task',
      required: true,
      validationMessage: 'Please enter who requested or assigned this additional task',
      hint: 'Provide the full name and title/position of the person who requested, assigned, or authorized this additional task.'
    },
    {
      name: 'taskDuration',
      type: 'text',
      label: 'Estimated Duration',
      header: 'Duration',
      placeholder: 'e.g. 30 minutes, 2 hours, ongoing',
      required: true,
      validationMessage: 'Please estimate how long this additional task took or will take',
      hint: 'Provide an estimate of the time required to complete this task (e.g., "45 minutes", "2 hours", "ongoing throughout event").'
    },
    {
      name: 'taskCompleted', // ← FIXED: Was 'taskStatus'
      type: 'dropdown',
      label: 'Task Completion Status',
      header: 'Completed',
      placeholder: 'Was this task completed?',
      options: [
        { value: 'Yes - Completed Successfully', label: 'Yes - Completed Successfully' },
        { value: 'Yes - Completed with Issues', label: 'Yes - Completed with Issues' },
        { value: 'No - In Progress', label: 'No - In Progress' },
        { value: 'No - On Hold/Delayed', label: 'No - On Hold/Delayed' },
        { value: 'No - Unable to Complete', label: 'No - Unable to Complete' }
      ],
      required: true,
      validationMessage: 'Please indicate whether this additional task was completed',
      hint: 'Indicate the completion status of this task.',
      displayTransform: (value) => {
        if (value && value.startsWith('Yes')) return 'Yes';
        if (value && value.startsWith('No')) return 'No';
        return value || '';
      }
    },
    {
      name: 'completionNotes', // ← FIXED: Was 'taskOutcome'
      type: 'textarea',
      label: 'Completion Notes/Results',
      header: 'Notes',
      placeholder: 'Describe the outcome, results, or current status of this task...',
      validationMessage: 'Please describe the outcome or results of this additional task',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document the task outcome including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Whether the task was completed successfully</li>
            <li>Results achieved or deliverables produced</li>
            <li>Any challenges or obstacles encountered</li>
            <li>Follow-up actions required</li>
            <li>Impact on overall event operations</li>
            <li>Lessons learned or recommendations</li>
          </ul>
        </div>
      )
    }
    // ← REMOVED: taskCategory field (not in parser template)
  ];

  return (
    <ModernDataTable
      suppressTitle={true}
      data={additionalTaskingItems}
      setData={setAdditionalTaskingItems}
      fields={taskingFields}
      addButtonText="Add Additional Tasking"
      emptyMessage="No additional taskings added yet."
      truncateLines={2}
      defaultDateTime={defaultDateTime}
    />
  );
};

export default Step10;